export default {
  warning:
    'Tätä ravintolaa ei ole liitetty brändiin. Jotta järjestelmä toimisi oikein, ravintolan on kuuluttava johonkin. Lisää tämä ravintola brändiin.',
  cta: 'Siirry brändeihin',
};
